
(function () {
  "use strict";

  const variantCache = {};

  function money(value) {
    const numberValue = Number(value || 0);
    return "$" + numberValue.toFixed(2);
  }

  function escapeHtml(text) {
    return String(text == null ? "" : text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  function normalizeNo(value) {
    return String(value == null ? "" : value);
  }

  function normalizeModelName(value) {
    const model = String(value == null ? "" : value).trim();
    if (!model) return "";
    return /^DJI\s+Agras\s+/i.test(model) ? model : "DJI Agras " + model;
  }

  function uniqueModels(models) {
    const seen = new Set();
    return models
      .map(normalizeModelName)
      .filter(Boolean)
      .filter(model => {
        const key = model.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  function modelsFromBodyHtml(bodyHtml) {
    if (!bodyHtml) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(String(bodyHtml), "text/html");
    const headings = Array.from(doc.querySelectorAll("h1, h2, h3, h4, strong, b"));
    const compatibilityHeading = headings.find(el =>
      String(el.textContent || "").trim().toLowerCase() === "compatibility"
    );

    if (!compatibilityHeading) return [];

    let list = compatibilityHeading.nextElementSibling;
    while (list && !["UL", "OL"].includes(list.tagName)) {
      if (/^H[1-6]$/.test(list.tagName)) return [];
      list = list.nextElementSibling;
    }

    if (!list) return [];
    return uniqueModels(
      Array.from(list.querySelectorAll("li")).map(li => li.textContent || "")
    );
  }

  function getCompatibleModels(root, part) {
    let models = [];

    if (Array.isArray(part.compatibleModels)) {
      models = part.compatibleModels;
    } else if (typeof part.compatibleModels === "string") {
      models = part.compatibleModels.split(/[,|;]/);
    } else if (Array.isArray(part.models)) {
      models = part.models;
    } else if (typeof part.models === "string") {
      models = part.models.split(/[,|;]/);
    } else if (part.compatibleModel) {
      models = [part.compatibleModel];
    }

    models = uniqueModels(models);

    if (!models.length) {
      models = modelsFromBodyHtml(part.bodyHtml);
    }

    if (!models.length) {
      const pageModel =
        root.getAttribute("data-model-name") ||
        root.getAttribute("data-compatible-model") ||
        root.dataset.modelName ||
        root.dataset.compatibleModel;

      if (pageModel) models = uniqueModels([pageModel]);
    }

    return models.length ? models : ["DJI Agras T50"];
  }

  function compatibleModelsHtml(root, part) {
    return getCompatibleModels(root, part)
      .map(model => '<span class="drt-compatible-model">' + escapeHtml(model) + "</span>")
      .join("<br>");
  }

  function normalizePartsData(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.parts)) return data.parts;
    if (data && Array.isArray(data.items)) return data.items;
    if (data && Array.isArray(data.data)) return data.data;
    return [];
  }

  async function loadPartsData(root, dataEl) {
    let parts = [];

    try {
      parts = normalizePartsData(JSON.parse(dataEl.textContent || "[]"));
    } catch (error) {
      console.error("Invalid inline DRT parts JSON", error);
      parts = [];
    }

    if (parts.length) return parts;

    const jsonUrl = root.getAttribute("data-drt-parts-json-url");
    if (!jsonUrl) return parts;

    try {
      const response = await fetch(jsonUrl, { headers: { "Accept": "application/json" } });
      if (!response.ok) throw new Error("Unable to load DRT parts JSON asset: " + response.status);
      const data = await response.json();
      return normalizePartsData(data);
    } catch (error) {
      console.error("Unable to load DRT parts JSON asset", error);
      return [];
    }
  }

  function productUrl(part) {
    return part.handle ? "/products/" + part.handle : "/pages/contact";
  }

  function canAdd(part) {
    return part && part.status !== "excluded" && part.handle;
  }

  function createModal() {
    if (document.getElementById("drtImageModal")) return;
    const modal = document.createElement("div");
    modal.className = "drt-image-modal";
    modal.id = "drtImageModal";
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = '<div class="drt-image-modal-content" role="dialog" aria-modal="true" aria-label="Product image preview"><button class="drt-image-modal-close" type="button" aria-label="Close image preview">×</button><img id="drtImageModalImg" src="" alt="Product image preview"></div>';
    document.body.appendChild(modal);
  }

  function openImageModal(imageUrl) {
    if (!imageUrl) return;
    createModal();
    const modal = document.getElementById("drtImageModal");
    const img = document.getElementById("drtImageModalImg");
    img.src = imageUrl;
    modal.classList.add("active");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeImageModal() {
    const modal = document.getElementById("drtImageModal");
    const img = document.getElementById("drtImageModalImg");
    if (!modal || !img) return;
    modal.classList.remove("active");
    modal.setAttribute("aria-hidden", "true");
    img.src = "";
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (event) {
    const modal = document.getElementById("drtImageModal");
    if (!modal) return;
    if (event.target.closest(".drt-image-modal-close")) {
      event.preventDefault();
      closeImageModal();
      return;
    }
    if (event.target === modal) closeImageModal();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeImageModal();
  });

  function adjustQty(input, delta) {
    if (!input) return;
    const current = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, current + delta);
  }

  async function getVariantId(part) {
    if (!part || !part.handle) throw new Error("Missing product handle.");
    if (variantCache[part.handle]) return variantCache[part.handle];
    const response = await fetch(productUrl(part) + ".js", { headers: { "Accept": "application/json" } });
    if (!response.ok) throw new Error("Unable to load Shopify product data.");
    const product = await response.json();
    const normalizedMaterial = String(part.material || "").toLowerCase();
    const normalizedSku = String(part.sku || "").toLowerCase();
    let variant = (product.variants || []).find(v => String(v.sku || "").toLowerCase() === normalizedSku)
      || (product.variants || []).find(v => String(v.sku || "").toLowerCase().startsWith(normalizedMaterial))
      || (product.variants || [])[0];
    if (!variant || !variant.id) throw new Error("No Shopify variant was found for this product.");
    variantCache[part.handle] = variant.id;
    return variant.id;
  }

  async function addToCart(root, part, qty) {
    if (!canAdd(part)) {
      window.location.href = "/pages/contact";
      return;
    }
    const quantity = Math.max(1, parseInt(qty, 10) || 1);
    try {
      const variantId = await getVariantId(part);
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!response.ok) throw new Error("Add to cart failed.");
      await response.json();
      const event = new CustomEvent("cart:refresh", { bubbles: true });
      root.dispatchEvent(event);
      alert("Added to cart successfully.");
    } catch (error) {
      console.error(error);
      alert("Unable to add this item to cart. Please check the Shopify product handle/SKU or try the product page.");
    }
  }


  async function addBulkToCart(root, rows, state) {
    const selectedItems = [];
    for (const row of rows) {
      const checkbox = row.querySelector("[data-drt-row-select]");
      if (!checkbox || !checkbox.checked) continue;
      const partNo = normalizeNo(checkbox.getAttribute("data-drt-row-select"));
      const part = state.parts.find(item => normalizeNo(item.no) === partNo);
      if (!canAdd(part)) continue;
      const qty = Math.max(1, parseInt(row.querySelector("[data-drt-table-qty]")?.value || "1", 10) || 1);
      selectedItems.push({ part, qty });
    }

    if (!selectedItems.length) {
      alert("Please select at least one part first.");
      return;
    }

    const trigger = root.querySelector("[data-drt-add-selected-rows]");
    const originalText = trigger ? trigger.textContent : "";
    if (trigger) {
      trigger.disabled = true;
      trigger.textContent = "Adding...";
    }

    try {
      const items = [];
      for (const item of selectedItems) {
        const variantId = await getVariantId(item.part);
        items.push({ id: variantId, quantity: item.qty });
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) throw new Error("Bulk add to cart failed.");
      await response.json();
      root.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      alert("Selected parts were added to cart successfully.");
    } catch (error) {
      console.error(error);
      alert("Unable to add selected parts to cart. Please check product handles/SKUs or add items individually.");
    } finally {
      if (trigger) {
        trigger.disabled = false;
        trigger.textContent = originalText;
      }
    }
  }

  function updateBulkBar(root) {
    const checkboxes = Array.from(root.querySelectorAll("[data-drt-row-select]"));
    const checked = checkboxes.filter(item => item.checked);
    const countEl = root.querySelector("[data-drt-selected-count]");
    const totalEl = root.querySelector("[data-drt-selected-total]");

    if (countEl) countEl.textContent = String(checked.length);

    if (totalEl) {
      let total = 0;
      checked.forEach(checkbox => {
        const row = checkbox.closest("tr");
        const price = Number(row?.getAttribute("data-drt-row-price") || 0);
        const qty = Math.max(1, parseInt(row?.querySelector("[data-drt-table-qty]")?.value || "1", 10) || 1);
        total += price * qty;
      });
      totalEl.textContent = money(total);
    }

    const selectAll = root.querySelector("[data-drt-select-all]");
    if (selectAll && checkboxes.length) {
      selectAll.checked = checked.length === checkboxes.length;
      selectAll.indeterminate = checked.length > 0 && checked.length < checkboxes.length;
    }
  }

  function filterParts(parts, query) {
    const q = String(query || "").trim().toLowerCase();
    if (!q) return parts;
    return parts.filter(part => {
      return String(part.no).includes(q)
        || String(part.material || "").toLowerCase().includes(q)
        || String(part.fullMaterial || "").toLowerCase().includes(q)
        || String(part.sku || "").toLowerCase().includes(q)
        || String(part.name || "").toLowerCase().includes(q)
        || String(part.shortName || "").toLowerCase().includes(q);
    });
  }


  function formatDescriptionHtml(html) {
    if (!html) return "";
    let output = String(html);

    if (!/<[a-z][\s\S]*>/i.test(output)) {
      output = output
        .split(/\n{2,}/)
        .map(block => "<p>" + escapeHtml(block).replace(/\n/g, "<br>") + "</p>")
        .join("");
    }

    output = output
      .replace(/(<br\s*\/?>\s*){2,}/gi, "</p><p>")
      .replace(/(<br\s*\/?>\s*)?(<strong>|<b>)(Product Category|Compatibility|Package Includes|Product Information|Shipping Note|Note)(<\/strong>|<\/b>)/gi, "</p><h3>$3</h3><p>")
      .replace(/<p>\s*<\/p>/gi, "");

    return output;
  }

  function renderNumbers(state) {
    const grid = state.root.querySelector("[data-drt-number-grid]");
    grid.innerHTML = "";
    state.filtered.forEach(part => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "drt-number-btn" + (normalizeNo(part.no) === normalizeNo(state.selectedNo) ? " active" : "");
      button.textContent = part.no;
      button.setAttribute("data-drt-select", String(part.no));
      grid.appendChild(button);
    });
  }

  function renderSelected(state) {
    const box = state.root.querySelector("[data-drt-selected]");
    const part = state.parts.find(item => normalizeNo(item.no) === normalizeNo(state.selectedNo));
    if (!part) {
      box.innerHTML = '<div class="drt-empty">No matching part found.</div>';
      return;
    }
    const imageHtml = part.imageUrl
      ? '<div class="drt-image-wrap"><img class="drt-product-image" src="' + escapeHtml(part.imageUrl) + '" alt="' + escapeHtml(part.shortName || part.name) + '" loading="lazy" data-drt-image-open="' + escapeHtml(part.imageUrl) + '"><div class="drt-image-hint">Click image to enlarge</div></div>'
      : '<div class="drt-image-wrap"><div class="drt-image-hint">No product image available yet</div></div>';
    const oversizeBadge = part.oversize ? '<span class="drt-badge drt-badge-oversize">Oversize / Freight</span>' : '';
    const oversizeWarning = part.oversize ? '<div class="drt-oversize-warning">This is an oversize item and may require freight or special shipping. Final shipping cost may need confirmation before fulfillment.</div>' : '';
    const descriptionHtml = part.bodyHtml ? '<button class="drt-description-toggle" type="button" data-drt-description-toggle>View Product Details</button><div class="drt-description-content">' + formatDescriptionHtml(part.bodyHtml) + '</div>' : '';
    const actionHtml = canAdd(part)
      ? '<div class="drt-add-row"><div class="drt-qty-stepper"><button type="button" data-drt-qty-minus aria-label="Decrease quantity">−</button><input type="number" min="1" value="1" data-drt-selected-qty><button type="button" data-drt-qty-plus aria-label="Increase quantity">+</button></div><button class="drt-add-btn" type="button" data-drt-add-selected>Add to Cart</button></div><a class="drt-view-btn" href="' + productUrl(part) + '" target="_blank" rel="noopener noreferrer">View Full Product Info</a>'
      : '<a class="drt-contact-btn" href="/pages/contact">Contact Us</a>';

    box.innerHTML = '<div class="drt-badges"><span class="drt-badge">No. ' + part.no + '</span><span class="drt-badge drt-badge-available">Available</span>' + oversizeBadge + '</div>'
      + '<h3 class="drt-product-title">' + escapeHtml(part.name) + '</h3>'
      + imageHtml
      + '<div class="drt-info-grid"><div class="drt-info-item"><span class="drt-info-label">Material Number</span><span class="drt-info-value">' + escapeHtml(part.material) + '</span></div><div class="drt-info-item"><span class="drt-info-label">Price</span><span class="drt-info-value">' + money(part.price) + '</span></div><div class="drt-info-item"><span class="drt-info-label">Compatible Model</span><span class="drt-info-value">' + compatibleModelsHtml(state.root, part) + '</span></div><div class="drt-info-item"><span class="drt-info-label">Shipping Class</span><span class="drt-info-value">' + (part.oversize ? 'Oversize / Freight' : 'Standard') + '</span></div></div>'
      + oversizeWarning + actionHtml + descriptionHtml;
  }

  function renderTable(state) {
    const tbody = state.root.querySelector("[data-drt-table-body]");
    tbody.innerHTML = "";
    state.filtered.forEach(part => {
      const row = document.createElement("tr");
      row.setAttribute("data-drt-row-price", String(Number(part.price || 0)));
      row.innerHTML = '<td class="drt-table-select-cell"><input class="drt-row-checkbox" type="checkbox" data-drt-row-select="' + escapeHtml(part.no) + '" aria-label="Select part No. ' + escapeHtml(part.no) + '"></td>'
        + '<td><strong>' + part.no + '</strong></td>'
        + '<td class="drt-table-sku">' + escapeHtml(part.material) + '</td>'
        + '<td>' + escapeHtml(part.shortName || part.name) + '</td>'
        + '<td class="drt-table-price">' + money(part.price) + '</td>'
        + '<td>' + (part.oversize ? 'Yes' : 'No') + '</td>'
        + '<td><div class="drt-table-qty-stepper"><button type="button" data-drt-qty-minus aria-label="Decrease quantity">−</button><input type="number" min="1" value="1" data-drt-table-qty><button type="button" data-drt-qty-plus aria-label="Increase quantity">+</button></div></td>'
        + '<td><button class="drt-table-add-btn" type="button" data-drt-add-table="' + escapeHtml(part.no) + '">Add</button></td>';
      tbody.appendChild(row);
    });
    updateBulkBar(state.root);
  }

  function renderAll(state) {
    state.filtered = filterParts(state.parts, state.searchInput.value);
    if (!state.filtered.some(part => normalizeNo(part.no) === normalizeNo(state.selectedNo))) state.selectedNo = state.filtered.length ? state.filtered[0].no : null;
    renderNumbers(state);
    renderSelected(state);
    renderTable(state);
  }

  async function initSection(root) {
    if (!root || root.dataset.drtInitialized === "true") return;
    const dataEl = root.querySelector("[data-drt-parts-json]");
    if (!dataEl) return;

    root.dataset.drtInitialized = "true";

    const parts = await loadPartsData(root, dataEl);
    const state = { root, parts, filtered: parts.slice(), selectedNo: parts[0] ? normalizeNo(parts[0].no) : null, searchInput: root.querySelector("[data-drt-search]") };
    root.__drtPartsState = state;

    if (!state.searchInput) return;
    state.searchInput.addEventListener("input", () => renderAll(state));
    root.addEventListener("input", function (event) {
      if (event.target.closest("[data-drt-table-qty]")) updateBulkBar(root);
    });
    root.addEventListener("click", function (event) {
      const selectButton = event.target.closest("[data-drt-select]");
      if (selectButton) {
        state.selectedNo = normalizeNo(selectButton.getAttribute("data-drt-select"));
        state.searchInput.value = "";
        renderAll(state);
        return;
      }
      const image = event.target.closest("[data-drt-image-open]");
      if (image) {
        openImageModal(image.getAttribute("data-drt-image-open"));
        return;
      }
      const toggle = event.target.closest("[data-drt-description-toggle]");
      if (toggle) {
        const content = toggle.nextElementSibling;
        const isOpen = content.classList.toggle("active");
        toggle.classList.toggle("active", isOpen);
        toggle.textContent = isOpen ? "Hide Product Details" : "View Product Details";
        return;
      }
      const minus = event.target.closest("[data-drt-qty-minus]");
      const plus = event.target.closest("[data-drt-qty-plus]");
      if (minus || plus) {
        const wrap = event.target.closest(".drt-qty-stepper, .drt-table-qty-stepper");
        adjustQty(wrap ? wrap.querySelector("input") : null, plus ? 1 : -1);
        updateBulkBar(root);
        return;
      }
      const rowSelect = event.target.closest("[data-drt-row-select]");
      if (rowSelect) {
        updateBulkBar(root);
        return;
      }
      const selectAll = event.target.closest("[data-drt-select-all]");
      if (selectAll) {
        root.querySelectorAll("[data-drt-row-select]").forEach(item => { item.checked = selectAll.checked; });
        updateBulkBar(root);
        return;
      }
      const clearSelectedRows = event.target.closest("[data-drt-clear-selected-rows]");
      if (clearSelectedRows) {
        root.querySelectorAll("[data-drt-row-select]").forEach(item => { item.checked = false; });
        updateBulkBar(root);
        return;
      }
      const addSelectedRows = event.target.closest("[data-drt-add-selected-rows]");
      if (addSelectedRows) {
        addBulkToCart(root, Array.from(root.querySelectorAll("[data-drt-table-body] tr")), state);
        return;
      }
      const addSelected = event.target.closest("[data-drt-add-selected]");
      if (addSelected) {
        const part = state.parts.find(item => normalizeNo(item.no) === normalizeNo(state.selectedNo));
        const qty = root.querySelector("[data-drt-selected-qty]")?.value || 1;
        addToCart(root, part, qty);
        return;
      }
      const addTable = event.target.closest("[data-drt-add-table]");
      if (addTable) {
        const partNo = normalizeNo(addTable.getAttribute("data-drt-add-table"));
        const part = state.parts.find(item => normalizeNo(item.no) === partNo);
        const row = addTable.closest("tr");
        const qty = row.querySelector("[data-drt-table-qty]")?.value || 1;
        addToCart(root, part, qty);
      }
    });
    renderAll(state);
  }

  function initAll() {
    document.querySelectorAll("[data-drt-parts-diagram]").forEach(initSection);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
